// removed by extract-text-webpack-plugin
module.exports = {"container":"s0zWbi7JmWsFaQgp3X5-7"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/Status/styles.css
// module id = 2839
// module chunks = 0